import { ArrowLeft } from "lucide-react";
import { CONTACT_EMAIL, LEGAL_LINE } from "../content";

const SECTIONS = [
  {
    title: "1. Quem somos",
    body: `Este site é operado pela DealFlow Lab (${LEGAL_LINE.replace("DealFlow Lab · ", "")}). Esta Política de Privacidade descreve como coletamos, usamos e protegemos os seus dados pessoais, em conformidade com a Lei Geral de Proteção de Dados — LGPD (Lei nº 13.709/2018).`,
  },
  {
    title: "2. Dados que coletamos",
    body: `Coletamos os dados que você fornece voluntariamente no formulário de contato: nome, empresa, WhatsApp, e-mail, ticket médio do seu produto e mensagem. Também podemos coletar dados de navegação (cookies) para medir a performance do site.`,
  },
  {
    title: "3. Finalidade do tratamento",
    body: `Usamos os seus dados exclusivamente para: responder ao seu pedido de diagnóstico, dar sequência ao contato comercial por WhatsApp ou e-mail e melhorar a experiência de navegação. Não vendemos nem compartilhamos os seus dados com terceiros para fins de marketing.`,
  },
  {
    title: "4. Base legal e compartilhamento",
    body: `O tratamento é baseado no seu consentimento (art. 7º, I, da LGPD) e no legítimo interesse de execução de procedimentos preliminares a contrato (art. 7º, V). Os dados ficam armazenados em ambiente seguro e só são acessados pela equipe da DealFlow Lab.`,
  },
  {
    title: "5. Cookies",
    body: `Utilizamos cookies de medição de audiência e desempenho. Você pode aceitar ou recusar o uso por meio do banner exibido na primeira visita, e pode alterar a sua escolha limpando os dados de navegação do seu navegador.`,
  },
  {
    title: "6. Seus direitos",
    body: `Você pode solicitar, a qualquer momento, a confirmação, o acesso, a correção, a anonimização, a portabilidade ou a eliminação dos seus dados pessoais, bem como revogar o consentimento.`,
  },
  {
    title: "7. Canal do encarregado (DPO)",
    body: `Para exercer os seus direitos ou tirar dúvidas sobre esta política, escreva para ${CONTACT_EMAIL} ou chame no WhatsApp comercial (81) 99921-4339.`,
  },
  {
    title: "8. Atualizações",
    body: `Esta política pode ser atualizada para refletir mudanças legais ou operacionais. A versão vigente estará sempre disponível nesta página. Última atualização: julho de 2026.`,
  },
];

export default function Privacidade() {
  return (
    <div data-testid="privacidade-page" className="bg-tinta min-h-screen">
      <header className="border-b border-inkline">
        <div className="max-w-4xl mx-auto px-5 sm:px-8 h-16 md:h-[72px] flex items-center justify-between">
          <a href="/" aria-label="DealFlow Lab — voltar à página inicial">
            <img src="/assets/logo-horizontal.webp" alt="DealFlow Lab" className="h-9 w-auto" />
          </a>
          <a
            data-testid="privacidade-back-link"
            href="/"
            className="inline-flex items-center gap-2 font-sora text-xs font-bold text-creme/80 hover:text-lima transition-colors duration-150"
          >
            <ArrowLeft className="w-4 h-4" /> Voltar
          </a>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-5 sm:px-8 py-16 md:py-24">
        <p className="label-caps text-lima mb-5">LGPD · Lei nº 13.709/2018</p>
        <h1
          data-testid="privacidade-title"
          className="headline text-creme text-3xl sm:text-4xl lg:text-5xl"
        >
          Política de Privacidade
        </h1>

        <div className="mt-12 space-y-10">
          {SECTIONS.map((s) => (
            <section key={s.title}>
              <h2 className="font-sora font-bold text-creme text-lg tracking-[-0.025em]">
                {s.title}
              </h2>
              <p className="mt-3 text-muteddark text-sm leading-relaxed">{s.body}</p>
            </section>
          ))}
        </div>

        <p className="mt-16 pt-8 border-t border-inkline text-xs text-muteddark/70">
          {LEGAL_LINE}
        </p>
      </main>
    </div>
  );
}
